import { useQueryPrimaryComplianceEntity } from "../../../shared/hooks/useQueryPrimaryComplianceEntity";
import { DataView } from "../../../shared/components/DataView";

export const ReviewOriginalBusinessName: React.FC = () => {
  const queryEntity = useQueryPrimaryComplianceEntity();

  return (
    <DataView
      title="Legal business name"
      pill={{ text: "Original" }}
      data={[
        {
          label: "Legal business name",
          value: queryEntity.data?.legalName
        },
        {
          label: "Doing business as (DBA)",
          value: queryEntity.data?.doingBusinessAs
        }
      ]}
    />
  );
};
